export default {
  // Login
  'login.title': '管理者ログイン',
  'login.subtitle': '管理者アカウントでログインしてください。アカウントはスーパー管理者が割り当てます',
  'login.email': 'ユーザー名 / メール',
  'login.emailPlaceholder': 'ユーザー名またはメールアドレスを入力',
  'login.password': 'パスワード',
  'login.passwordPlaceholder': 'パスワードを入力',
  'login.submit': 'ログイン',
  'login.loading': 'ログイン中...',
  'login.failed': 'ログイン失敗',
  'login.networkError': 'ネットワークエラー',
  'login.unknownError': '不明なエラー',
  'login.emptyFields': 'ユーザー名とパスワードを入力してください',
  'login.showPassword': 'パスワードを表示',
  'login.hidePassword': 'パスワードを非表示',
  'login.noSelfRegister': 'セルフ登録は提供していません。アカウントが必要な場合はスーパー管理者にお問い合わせください。',
  'login.footerText': 'マルチテナント管理プラットフォーム',
  'login.brandTitle1': 'マルチテナント',
  'login.brandTitle2': '管理コンソール',
  'login.brandSlogan': 'テナント、ユーザー、リソース、課金ポリシーを統合管理し、エンタープライズ運用をより効率的かつ安全に。',
  'login.feature1Title': 'アクセス制御',
  'login.feature1Desc': 'エンタープライズ級の権限管理と監査ログ',
  'login.feature2Title': 'データ分離',
  'login.feature2Desc': 'マルチテナントデータ分離とクォータ管理',
  'login.feature3Title': 'モニタリング',
  'login.feature3Desc': 'リアルタイム監視ダッシュボードとレポート分析',

  // Sidebar
  'sidebar.home': 'ダッシュボード',
  'sidebar.users': 'ユーザーと権限',
  'sidebar.resources': '機能とリソース',
  'sidebar.tenants': 'テナント管理',
  'sidebar.audit': '監査ログ',
  'sidebar.reports': 'レポート分析',
  'sidebar.settings': 'システム設定',
  'sidebar.admin': 'システム管理者',

  // Header
  'header.search': 'テナント、ユーザー、リソースを検索...',
  'header.notifications': '通知',
  'header.viewAll': 'すべての通知を表示',
  'header.profile': 'プロフィール',
  'header.settings': '設定',
  'header.logout': 'ログアウト',
  'header.notif.newTenant': '新規テナント登録',
  'header.notif.newTenantMsg': 'テックイノベーション社が登録しました',
  'header.notif.apiWarning': 'API使用量警告',
  'header.notif.apiWarningMsg': 'テナントT002がクォータ上限に近づいています',
  'header.notif.systemUpdate': 'システム更新',
  'header.notif.systemUpdateMsg': '今夜システムメンテナンスを実施します',
  'header.notif.5minAgo': '5分前',
  'header.notif.1hourAgo': '1時間前',
  'header.notif.3hoursAgo': '3時間前',

  // Home
  'home.title': '管理概要',
  'home.subtitle': 'お帰りなさい。マルチテナント管理プラットフォームです',
  'home.totalTenants': '総テナント数',
  'home.totalUsers': '総ユーザー数',
  'home.apiCalls': 'API呼び出し',
  'home.totalRevenue': '総収入',
  'home.totalSkills': '総スキル数',
  'home.chatSessions': 'チャットセッション',
  'home.totalMessages': '総メッセージ数',
  'home.systemHealth': 'システム健全性',
  'home.active': 'アクティブ',
  'home.activeShort': 'アクティブ',
  'home.thisMonth': '今月',
  'home.published': '公開済み',
  'home.cumulative': '累計',
  'home.running': '正常稼働中',
  'home.vsLastMonth': '前月比',
  'home.apiTrend': 'API使用トレンド',
  'home.revenueTrend': '収入トレンド',
  'home.quickAccess': 'クイックアクセス',
  'home.recentActivity': '最近のアクティビティ',
  'home.viewAll': 'すべて表示',
  'home.tenantDistribution': 'テナント分布',
  'home.success': '成功',
  'home.failed': '失敗',

  // Tenants
  'tenants.title': 'テナント管理',
  'tenants.subtitle': 'すべてのテナントの設定、クォータ、課金ポリシーを管理',
  'tenants.export': 'リストをエクスポート',
  'tenants.create': '新規テナント',
  'tenants.total': '合計',
  'tenants.unit': 'テナント',
  'tenants.clickTip': '行をクリックして詳細を表示',
  'tenants.showing': '表示',
  'tenants.to': '-',
  'tenants.of': '件中',
  'tenants.records': '件',
  'tenants.createTitle': '新規テナント',
  'tenants.createSuccess': 'テナントが正常に作成されました！',
  'tenants.createFailed': '作成失敗',
  'tenants.tenantName': 'テナント名',
  'tenants.subdomain': 'サブドメイン',
  'tenants.contactName': '連絡先名',
  'tenants.contactEmail': '連絡先メール',
  'tenants.planType': 'プランタイプ',
  'tenants.deployRegion': 'デプロイリージョン',
  'tenants.cancel': 'キャンセル',
  'tenants.createBtn': 'テナント作成',
  'tenants.namePlaceholder': '例：テックイノベーション社',
  'tenants.domainPlaceholder': 'techcorp',
  'tenants.contactPlaceholder': '山田太郎',
  'tenants.emailPlaceholder': 'admin@company.com',
  'tenants.plan.basic': 'ベーシック',
  'tenants.plan.professional': 'プロフェッショナル',
  'tenants.plan.enterprise': 'エンタープライズ',
  'tenants.region.east': '華東',
  'tenants.region.north': '華北',
  'tenants.region.south': '華南',
  'tenants.region.west': '西部',

  // Tenant Stats
  'tenantStats.total': '総テナント数',
  'tenantStats.active': 'アクティブテナント',
  'tenantStats.totalUsers': '総ユーザー数',
  'tenantStats.monthlyRevenue': '月間収入',

  // Tenant Filters
  'tenantFilters.search': 'テナント名、ドメイン、連絡先を検索...',
  'tenantFilters.allPlans': 'すべてのプラン',
  'tenantFilters.allStatus': 'すべてのステータス',
  'tenantFilters.active': 'アクティブ',
  'tenantFilters.suspended': '停止中',
  'tenantFilters.trial': 'トライアル',

  // Tenant Table
  'tenantTable.info': 'テナント情報',
  'tenantTable.plan': 'プラン',
  'tenantTable.status': 'ステータス',
  'tenantTable.users': 'ユーザー数',
  'tenantTable.apiCalls': 'API呼び出し',
  'tenantTable.storage': 'ストレージ',
  'tenantTable.region': 'リージョン',
  'tenantTable.lastActive': '最終アクティブ',
  'tenantTable.actions': '操作',
  'tenantTable.viewDetail': '詳細を表示',
  'tenantTable.edit': '編集',
  'tenantTable.more': 'その他',
  'tenantTable.noMatch': '一致するテナントがありません',

  // Tenant Detail
  'tenantDetail.overview': '概要',
  'tenantDetail.quotaMgmt': 'クォータ管理',
  'tenantDetail.dataIsolation': 'データ分離',
  'tenantDetail.billing': '課金情報',
  'tenantDetail.createdAt': '作成日',
  'tenantDetail.resourceUsage': 'リソース使用状況',
  'tenantDetail.apiCallUsage': 'API呼び出し量',
  'tenantDetail.storageUsage': 'ストレージ',
  'tenantDetail.userCount': 'ユーザー数',
  'tenantDetail.contactInfo': '連絡先情報',
  'tenantDetail.contact': '連絡先',
  'tenantDetail.email': 'メール',
  'tenantDetail.deployRegion': 'デプロイリージョン',
  'tenantDetail.lastActive': '最終アクティブ',
  'tenantDetail.enabledFeatures': '有効な機能',
  'tenantDetail.tags': 'テナントタグ',
  'tenantDetail.quickActions': 'クイックアクション',
  'tenantDetail.suspend': 'テナントを停止',
  'tenantDetail.resume': 'テナントを再開',
  'tenantDetail.sendNotice': '通知を送信',
  'tenantDetail.simulateLogin': 'ログインをシミュレート',
  'tenantDetail.exportData': 'データをエクスポート',
  'tenantDetail.quotaSaved': 'クォータが保存されました',
  'tenantDetail.quotaSettings': 'クォータ設定',
  'tenantDetail.quotaDesc': 'このテナントのリソース使用上限を調整',
  'tenantDetail.maxUsers': '最大ユーザー数',
  'tenantDetail.apiCallsMonth': 'API呼び出し/月',
  'tenantDetail.storageSpace': 'ストレージ',
  'tenantDetail.currentUsage': '現在の使用量',
  'tenantDetail.saveQuota': 'クォータ設定を保存',
  'tenantDetail.isolationSaved': '分離ポリシーが保存されました',
  'tenantDetail.isolationPolicy': 'データ分離ポリシー',
  'tenantDetail.isolationDesc': 'このテナントのデータ保存と分離方法を選択',
  'tenantDetail.dedicated': '専用分離',
  'tenantDetail.dedicatedDesc': '専用データベースインスタンスを割り当て、データ完全分離、最高セキュリティ',
  'tenantDetail.shared': '共有分離',
  'tenantDetail.sharedDesc': '他のテナントとデータベースインスタンスを共有、行レベルセキュリティで分離',
  'tenantDetail.recommended': '推奨',
  'tenantDetail.permissionConfig': '権限設定',
  'tenantDetail.crossTenantAccess': 'クロステナントデータアクセス',
  'tenantDetail.crossTenantDesc': 'このテナントが他のテナントの公開データにアクセスすることを許可',
  'tenantDetail.apiRateLimit': 'APIレート制限',
  'tenantDetail.apiRateLimitDesc': 'このテナントのAPIリクエストにレート制限を適用',
  'tenantDetail.dataExport': 'データエクスポート権限',
  'tenantDetail.dataExportDesc': 'このテナントがデータをエクスポートすることを許可',
  'tenantDetail.auditAccess': '監査ログアクセス',
  'tenantDetail.auditAccessDesc': 'このテナントが自身の監査ログを閲覧することを許可',
  'tenantDetail.saveIsolation': '分離ポリシーを保存',
  'tenantDetail.currentPlan': '現在のプラン費用',
  'tenantDetail.perMonth': '/ 月',
  'tenantDetail.nextBilling': '次回請求日',
  'tenantDetail.billDetail': '請求明細',
  'tenantDetail.baseFee': '基本プラン費',
  'tenantDetail.apiCallFee': 'API呼び出し費',
  'tenantDetail.storageFee': 'ストレージ費',
  'tenantDetail.supportFee': 'テクニカルサポート費',
  'tenantDetail.total': '合計',
  'tenantDetail.historyBills': '請求履歴',
  'tenantDetail.paid': '支払済み',
  'tenantDetail.download': 'ダウンロード',
  'tenantDetail.feature.aiModels': 'AIモデル',
  'tenantDetail.feature.apiAccess': 'APIアクセス',
  'tenantDetail.feature.advancedAnalytics': '高度な分析',
  'tenantDetail.feature.basicAnalytics': '基本分析',
  'tenantDetail.feature.customDomain': 'カスタムドメイン',
  'tenantDetail.feature.sso': 'SSOシングルサインオン',
  'tenantDetail.feature.whiteLabel': 'ホワイトラベル',

  // Users
  'users.title': 'ユーザーと権限管理',
  'users.subtitle': 'すべてのテナントのユーザーアカウントと権限設定を管理',
  'users.addUser': 'ユーザー追加',
  'users.totalUsers': '総ユーザー数',
  'users.activeUsers': 'アクティブユーザー',
  'users.admins': '管理者',
  'users.developers': '開発者',
  'users.loading': '読み込み中...',

  // User Filters
  'userFilters.search': 'ユーザー名、メール、テナントを検索...',
  'userFilters.allRoles': 'すべての役割',
  'userFilters.admin': '管理者',
  'userFilters.user': '一般ユーザー',
  'userFilters.developer': '開発者',
  'userFilters.allStatus': 'すべてのステータス',
  'userFilters.active': 'アクティブ',
  'userFilters.inactive': '未アクティブ',
  'userFilters.moreFilters': 'その他のフィルター',

  // User Table
  'userTable.user': 'ユーザー',
  'userTable.tenant': 'テナント',
  'userTable.role': '役割',
  'userTable.status': 'ステータス',
  'userTable.lastLogin': '最終ログイン',
  'userTable.actions': '操作',
  'userTable.role.admin': '管理者',
  'userTable.role.user': 'ユーザー',
  'userTable.role.developer': '開発者',
  'userTable.status.active': 'アクティブ',
  'userTable.status.inactive': '未アクティブ',

  // Resources
  'resources.title': 'サービス設定',
  'resources.subtitle': 'AIモデル、APIキー、サードパーティサービスの統合を管理',
  'resources.refresh': '更新',
  'resources.addConfig': '設定追加',
  'resources.totalConfigs': '総設定数',
  'resources.active': 'アクティブ',
  'resources.categories': 'カテゴリ',
  'resources.secrets': 'シークレット',
  'resources.addTitle': '新規設定追加',
  'resources.category': 'カテゴリ',
  'resources.configKey': '設定キー',
  'resources.displayName': '表示名',
  'resources.value': '値',
  'resources.description': '説明',
  'resources.secretValue': 'シークレット値',
  'resources.type': 'タイプ:',
  'resources.save': '保存',
  'resources.cancel': 'キャンセル',
  'resources.create': '作成',
  'resources.configs': '設定',
  'resources.items': '件',
  'resources.notConfigured': '未設定',
  'resources.noConfigs': '設定が見つかりません',
  'resources.running': '稼働中',
  'resources.maintenance': 'メンテナンス中',
  'resources.endpoint': 'エンドポイント',
  'resources.usageTenants': '使用テナント',
  'resources.usageUnit': '件',
  'resources.usage': '使用量',
  'resources.configure': '設定',
  'resources.stats': '統計',
  'resources.modelType': 'タイプ',
  'resources.version': 'バージョン',
  'resources.callCount': '呼び出し回数',
  'resources.cost': 'コスト',
  'resources.apiKey': 'APIキー',
  'resources.edit': '編集',
  'resources.usageStats': '使用統計',

  // Settings
  'settings.title': 'システム設定',
  'settings.subtitle': 'プラットフォームのグローバル設定、セキュリティポリシー、多言語オプションを管理',
  'settings.tab.general': '基本設定',
  'settings.tab.services': 'サービス設定',
  'settings.tab.security': 'セキュリティ',
  'settings.tab.notification': '通知設定',
  'settings.tab.billing': '課金プラン',
  'settings.tab.locale': '多言語',
  'settings.systemInfo': 'システム情報',
  'settings.version': 'バージョン',
  'settings.environment': '環境',
  'settings.production': '本番環境',
  'settings.availability': '可用性',
  'settings.lastBackup': '最終バックアップ',
  'settings.todayAt': '本日 03:00',

  // General Settings
  'general.platformInfo': 'プラットフォーム基本情報',
  'general.platformName': 'プラットフォーム名',
  'general.platformUrl': 'プラットフォームURL',
  'general.supportEmail': 'サポートメール',
  'general.timezone': 'タイムゾーン',
  'general.dateFormat': '日付形式',
  'general.maxTenants': '最大テナント数/プラン',
  'general.sessionMaintenance': 'セッションとメンテナンス',
  'general.sessionTimeout': 'セッションタイムアウト',
  'general.sessionTimeoutDesc': 'ユーザーが操作しない場合に自動ログアウト',
  'general.minutes': '分',
  'general.maintenanceMode': 'メンテナンスモード',
  'general.maintenanceDesc': '有効にするとフロントエンドユーザーにメンテナンスページが表示されます',
  'general.maintenanceWarning': 'メンテナンスモードが有効です。すべてのフロントエンドユーザーがプラットフォームにアクセスできません。',
  'general.reset': 'リセット',
  'general.save': '設定を保存',
  'general.saved': '保存済み',

  // Security Settings
  'security.authPolicy': '認証ポリシー',
  'security.mfa': '多要素認証 (MFA) を強制',
  'security.mfaDesc': 'すべての管理者アカウントでMFAを有効にする必要があります',
  'security.sso': 'SSOシングルサインオン',
  'security.ssoProtocol': '現在のプロトコル',
  'security.passwordPolicy': 'パスワードポリシー',
  'security.minLength': '最小パスワード長',
  'security.chars': '文字',
  'security.expireDays': 'パスワード有効期限',
  'security.days': '日',
  'security.maxAttempts': '最大ログイン失敗回数',
  'security.times': '回',
  'security.lockoutDuration': 'アカウントロック時間',
  'security.ipWhitelist': 'IPホワイトリスト',
  'security.ipPlaceholder': 'IPまたはCIDRを入力（例：192.168.1.0/24）',
  'security.add': '追加',
  'security.ipWhitelistDesc': '有効にすると、ホワイトリストのIPアドレスのみが管理パネルにアクセスできます。',
  'security.auditLog': '監査ログ',
  'security.retentionDays': 'ログ保持日数',
  'security.retentionDesc': '保持期間を超えたログは自動的にクリーンアップされます',
  'security.reset': 'リセット',
  'security.save': '設定を保存',
  'security.saved': '保存済み',

  // Notification Settings
  'notification.channels': '通知チャネル',
  'notification.email': 'メール通知',
  'notification.emailDesc': 'メールでシステムアラートとレポートを送信',
  'notification.sms': 'SMS通知',
  'notification.smsDesc': 'SMSで緊急アラートを送信',
  'notification.webhook': 'Webhookプッシュ',
  'notification.webhookDesc': '指定されたURLにイベントをプッシュ',
  'notification.webhookUrl': 'Webhook URL',
  'notification.alertEvents': 'アラートイベント',
  'notification.tenantCreate': '新規テナント登録',
  'notification.tenantCreateDesc': '新しいテナントが登録を完了した時に通知',
  'notification.quotaExceed': 'クォータ超過アラート',
  'notification.quotaExceedDesc': 'テナントのAPI使用量が90%を超えた時に通知',
  'notification.loginFail': 'ログイン失敗アラート',
  'notification.loginFailDesc': '連続ログイン失敗がしきい値に達した時に通知',
  'notification.systemError': 'システムエラーアラート',
  'notification.systemErrorDesc': '重大なシステムエラーが発生した時に即座に通知',
  'notification.scheduledReport': '定期レポート',
  'notification.dailyReport': '日次レポート',
  'notification.dailyReportDesc': '毎日の運用データサマリーを送信',
  'notification.sendTime': '送信時間',
  'notification.recipients': 'レポート受信者',
  'notification.emailPlaceholder': 'メールアドレスを入力',
  'notification.addBtn': '追加',
  'notification.reset': 'リセット',
  'notification.save': '設定を保存',
  'notification.saved': '保存済み',

  // Billing Plans
  'billing.saved': 'プランが保存されました',
  'billing.totalPlans': '総プラン数',
  'billing.activePlans': '有効なプラン',
  'billing.highestPrice': '最高価格',
  'billing.editing': '編集中',
  'billing.cancel': 'キャンセル',
  'billing.save': '保存',
  'billing.planName': 'プラン名',
  'billing.monthlyFee': '月額 (CNY)',
  'billing.apiCallsMonth': 'API呼び出し/月',
  'billing.storageSpace': 'ストレージ (GB)',
  'billing.maxUsers': '最大ユーザー数',
  'billing.supportType': 'サポート方式',
  'billing.disabled': '無効',
  'billing.perMonth': '/ 月',
  'billing.edit': '編集',
  'billing.apiLabel': 'API呼び出し',
  'billing.storageLabel': 'ストレージ',
  'billing.usersLabel': 'ユーザー数',
  'billing.supportLabel': 'サポート',

  // Locale Settings
  'locale.defaultLang': 'デフォルト言語設定',
  'locale.platformDefault': 'プラットフォームのデフォルト言語',
  'locale.platformDefaultDesc': '新規ユーザーが初めてアクセスする際に使用される言語',
  'locale.fallbackLang': 'フォールバック言語',
  'locale.fallbackLangDesc': '翻訳が見つからない場合に使用される言語',
  'locale.autoDetect': 'ブラウザ言語の自動検出',
  'locale.autoDetectDesc': 'ユーザーのブラウザ設定に基づいて自動的に言語を切り替え',
  'locale.tenantOverride': 'テナントの言語カスタマイズを許可',
  'locale.tenantOverrideDesc': 'テナントは設定でプラットフォームのデフォルト言語を上書きできます',
  'locale.langManagement': '言語パック管理',
  'locale.enabled': '有効',
  'locale.default': 'デフォルト',
  'locale.translationCoverage': '翻訳カバー率',
  'locale.cannotDisable': 'デフォルト言語は無効にできません',
  'locale.coverageNote': '翻訳カバー率について',
  'locale.coverageDesc': 'カバー率が80%未満の言語パックは、一部のUI要素がフォールバック言語で表示される場合があります。90%以上に達してから公開することをお勧めします。',
  'locale.save': '設定を保存',
  'locale.saved': '保存済み',

  // Service Configs
  'serviceConfigs.title': 'サービス設定',
  'serviceConfigs.subtitle': 'AIモデル、サードパーティAPIキー、外部サービス統合を管理',
  'serviceConfigs.refresh': '更新',

  // Audit
  'audit.title': '監査ログ',
  'audit.subtitle': 'システム操作記録とセキュリティ監査',
  'audit.totalLogs': '総ログ数',
  'audit.totalLogsDesc': 'すべての操作記録',
  'audit.successOps': '成功した操作',
  'audit.successRate': '成功率',
  'audit.failedOps': '失敗した操作',
  'audit.failedDesc': '注意が必要',
  'audit.todayOps': '今日の操作',
  'audit.todayDesc': '今日のアクティビティ',
  'audit.tenant': 'テナント',
  'audit.allTenants': 'すべてのテナント',
  'audit.actionType': '操作タイプ',
  'audit.allActions': 'すべての操作',
  'audit.status': 'ステータス',
  'audit.allStatus': 'すべてのステータス',
  'audit.success': '成功',
  'audit.failed': '失敗',
  'audit.timeRange': '時間範囲',
  'audit.allTime': 'すべての期間',
  'audit.today': '今日',
  'audit.last7days': '過去7日間',
  'audit.last30days': '過去30日間',
  'audit.keyword': 'キーワード検索',
  'audit.keywordPlaceholder': 'ユーザー、操作、リソースを検索...',
  'audit.found': '',
  'audit.records': '件のレコードが見つかりました',
  'audit.clearFilter': 'フィルターをクリア',
  'audit.time': '時間',
  'audit.user': 'ユーザー',
  'audit.action': '操作',
  'audit.resource': 'リソース',
  'audit.ipAddress': 'IPアドレス',
  'audit.actions': '操作',
  'audit.viewDetail': '詳細を表示',
  'audit.showing': '表示',
  'audit.prevPage': '前のページ',
  'audit.nextPage': '次のページ',
  'audit.detailTitle': '操作詳細',
  'audit.logId': 'ログID',
  'audit.operationTime': '操作時間',
  'audit.operationStatus': '操作ステータス',
  'audit.tenantInfo': 'テナント情報',
  'audit.tenantId': 'テナントID',
  'audit.tenantName': 'テナント名',
  'audit.operationUser': '操作ユーザー',
  'audit.userId': 'ユーザーID',
  'audit.userName': 'ユーザー名',
  'audit.operationInfo': '操作情報',
  'audit.operationType': '操作タイプ',
  'audit.operationResource': '操作リソース',
  'audit.operationDetail': '操作詳細',
  'audit.networkInfo': 'ネットワーク情報',
  'audit.userAgent': 'User Agent',

  // Reports
  'reports.title': 'レポート分析',
  'reports.subtitle': '多次元データ分析と可視化レポート',
  'reports.last7days': '過去7日間',
  'reports.last30days': '過去30日間',
  'reports.last90days': '過去90日間',
  'reports.apiTrend': 'API呼び出しトレンド',
  'reports.revenueCompare': 'テナント収入比較',
  'reports.resourceUsage': 'リソース使用率',
  'reports.userActivity': 'ユーザーアクティビティトレンド',
  'reports.activeUsers': 'アクティブユーザー',
  'reports.newUsers': '新規ユーザー',
  'reports.tenantSummary': 'テナントデータサマリー',
  'reports.tenantName': 'テナント名',
  'reports.apiCalls': 'API呼び出し',
  'reports.storageUsage': 'ストレージ使用量',
  'reports.userCount': 'ユーザー数',
  'reports.revenue': '収入',
  'reports.quotaUsage': 'クォータ使用率',

  // Language Switcher
  'langSwitcher.title': '言語 / Language',
};
